import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';

// Readme: https://angular.io/guide/router#teach-authguard-to-authenticate

@Injectable()
export class AuthguardService implements CanActivate {


    constructor(private router: Router, private authentication: AuthenticationService) {

    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let loggedIn = false;
        const promise = await this.authentication.checkAuthentication().then((val) => loggedIn = true, (val) => loggedIn = false);
        if (this.authentication.isLoggedin || loggedIn) {
            console.log('user is logged in');
            return true;
        }
        console.log('user is not logged in');
        this.router.navigate(['/login']);
        return false;

    }

}



// WEBPACK FOOTER //
// ./src/app/authguard.service.ts